import React from "react";
import "./Page1.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto1 from "../images/pagePhoto1.png";
//-----------------------------------------

function Page1() {
  return (
    <div className="page1_container">
      <div className="page1_bangla">
        প্রত্যেকটি Web-App কোনো বিশেষ প্রতিষ্ঠানের জন্য তৈরী। Web-App এর Web
        Address টি Google Chrome, Microsoft Edge, Internet Explorer, Mozilla
        Firefox অথবা যেকোনো Web Browser এর Address Bar এ টাইপ করে এই Web-App টি
        খুলুন। এই Web-App ব্যবহারের জন্য কোনো Software Installation এর প্রয়োজন
        নেই।
      </div>
      <div className="page1_english">
        Each Web-App is made for a particular business entity. The Web-App is to
        be opened by typing its “Web Address” in the “Address Bar” of any “Web
        Browser” such as Google Chrome, Microsoft Edge, Internet Explorer,
        Mozilla Firefox etc. There is no need for any Software Installation to
        use this Web-App.
      </div>
      <div className="page1_photo_div">
        <img className="page1_photo" src={pagePhoto1} alt="PagePhoto1 Logo" />
      </div>
      {/*--------------go to page-2 (next page) starts-------------*/}
      <NavLink
        to="/page2"
        className="goto_next_page"
        exact
        /*activeClassName="selected"*/
        /*id={showLinks ? "hidden" : ""}
          onClick={() => setShowLinks(!showLinks)}*/
      >
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-2 (next page) ends-------------*/}
    </div>
  );
}

export default Page1;
